import { render, staticRenderFns } from "./CustomArticle.vue?vue&type=template&id=a22112b4&scoped=true&"
import script from "./CustomArticle.vue?vue&type=script&lang=js&"
export * from "./CustomArticle.vue?vue&type=script&lang=js&"
import style0 from "./CustomArticle.vue?vue&type=style&index=0&id=a22112b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22112b4",
  null
  
)

export default component.exports